import {
  Box,
  Button,
  Paper,
  Typography,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import * as React from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ProductCarousel from "./ProductCarouselComponent";
import MeetingModal from "./MeetingModal";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import PagesIcon from "@mui/icons-material/Pages";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import AddOnsComponent from "./AddOns";
import Slider from "react-slick";
import "../css/customSlider.css";
import useGAEventsTracker from "./GAEventsHook";
import { CenterBox, SpaceBetweenBox } from "./commons/BoxAbstraction";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import PaletteIcon from "@mui/icons-material/Palette";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import BannerSection from "./BannerSection";
import ProductCard from "./ProductCard";
import { Category } from "@mui/icons-material";

const slides = [
  {
    title: "Personal",
    heading: "Personal",
    description:
      "Personalised reports highlighting the patient’s problematic parameters in great detail. The latest Smart Report to make waves in the industry.",
    illustration: "personal1.png",
    illustration1: "personal2.gif",
    positions: {
      top: "30px",
      topMd: "45px",
      topSm: "30px",
      left: "-50px",
      leftMd: "-9px",
      leftSm: "-9px",
    },
    dimension: { width: "300px", widthMd: "230px", widthSm: "230px" },
    audio:
      "https://dn96iqv3kf32j.cloudfront.net/brochure-images/audios/dynamicSRaudio.mp3",
    sample: "Dynamic Smart Report",
    images: [
      {
        src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-files/new-landing-page-resources/dynamic/digital/dynamic-digital-2.png",
        alt: "Personal Image 1",
      },
      {
        src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-files/new-landing-page-resources/dynamic/digital/dynamic-digital-3.png",
        alt: "Personal Image 2",
      },
    ],
  },
  {
    title: "Total",
    heading: "Total",
    description:
      "Comprehensive reports for those who want to know the most about their test results, with deep-dive into all the parameters. Perfect for health-conscious individuals.",
    illustration: "total1.png",
    illustration1: "total2.gif",
    positions: {
      top: 0,
      topMd: "30px",
      topSm: "3px",
      left: "-87px",
      leftMd: "0px",
      leftSm: "0px",
    },
    dimension: { width: "300px", widthMd: "230px", widthSm: "230px" },
    audio:
      "https://dn96iqv3kf32j.cloudfront.net/brochure-images/audios/advanceSRaudio.mp3",
    sample: "Advanced Smart Report",
    images: [
      {
        src: "https://dn96iqv3kf32j.cloudfront.net/brochure-images/advanced-section/Advanced-Report-0001.jpg",
        alt: "Total Image 1",
      },
      {
        src: "https://dn96iqv3kf32j.cloudfront.net/brochure-images/advanced-section/Advanced-Report-0002.jpg",
        alt: "Total Image 2",
      },
      {
        src: "https://dn96iqv3kf32j.cloudfront.net/brochure-images/advanced-section/Advanced-Report-0003.jpg",
        alt: "Total Image 3",
      },
      {
        src: "https://dn96iqv3kf32j.cloudfront.net/brochure-images/advanced-section/Advanced-Report-0004.jpg",
        alt: "Total Image 4",
      },
      {
        src: "https://dn96iqv3kf32j.cloudfront.net/brochure-images/advanced-section/Advanced-Report-0005.jpg",
        alt: "Total Image 5",
      },
      {
        src: "https://dn96iqv3kf32j.cloudfront.net/brochure-images/advanced-section/Advanced-Report-0006.jpg",
        alt: "Total Image 6",
      },
      {
        src: "https://dn96iqv3kf32j.cloudfront.net/brochure-images/advanced-section/Advanced-Report-0007.jpg",
        alt: "Total Image 7",
      },
    ],
  },
  {
    title: "Compact",
    heading: "Compact",
    description:
      "Simple reports for those who want to quickly check their results with compact graphs, minimal text and lesser pages. Great for doctors and acute patients.",
    illustration: "compact1.png",
    illustration1: "compact2.gif",
    positions: {
      top: "12px",
      topMd: "25px",
      topSm: "12px",
      left: "120px",
      leftMd: "120px",
      leftSm: "120px",
    },
    dimension: { width: "300px", widthMd: "265px", widthSm: "265px" },
    audio:
      "https://dn96iqv3kf32j.cloudfront.net/brochure-images/audios/compactSRaudio",
    sample: "Compact Smart Report",
    images: [
      {
        src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-files/new-landing-page-resources/compact/digital/compact-digital-2.png",
        alt: "Compact Image 1",
      },
      {
        src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-files/new-landing-page-resources/compact/digital/compact-digital-3.png",
        alt: "Compact Image 2",
      },
    ],
  },
  {
    title: "Trends",
    heading: "Trends",
    description:
      "Present & historical test results explained with easy-to-understand graphs and dynamic information. Creates maximum value to catch problematic trends of patients.",
    illustration: "trends1.png",
    illustration1: "trends2.gif",
    positions: {
      top: "-9px",
      topMd: "35px",
      topSm: "-9px",
      left: "144px",
      leftMd: "166px",
      leftSm: "110px",
    },
    dimension: { width: "230px", widthMd: "180px", widthSm: "180px" },
    audio:
      "https://dn96iqv3kf32j.cloudfront.net/brochure-images/audios/historicalSRaudio.mp3",
    sample: "Historical",
    images: [
      {
        // src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-files/new-landing-page-resources/new-historical.jpg",
        src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-images/brochureHistorical1-page1.jpg",
        alt: "Trends Image 1",
      },
      {
        // src: "https://dn96iqv3kf32j.cloudfront.net/brochure-images/updated-page1-historical.jpg",
        src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-images/brochureHistorical1-page2.jpg",
        alt: "Trends Image 2",
      },
      {
        // src: "https://dn96iqv3kf32j.cloudfront.net/brochure-images/updated-page2-historical.jpg",
        src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-images/brochureHistorical1-page3.jpg",
        alt: "Trends Image 3",
      },
      {
        // src: "https://dn96iqv3kf32j.cloudfront.net/brochure-images/updated-page3-historical.jpg",
        src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-images/brochureHistorical1-page4.jpg",
        alt: "Trends Image 4",
      },
    ],
  },
];
const addOns = [
  {
    title: "Body Summary",
    heading:
      "Your Smart Report summarised at the very beginning, with focus on out-of-range parameters. Available in 3 versions - human body, small table, big table.",
    picture: "humanbodysummary.png",
    images: [
      {
        src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-files/bodySummaryMale.png",
        alt: "Body Summary Male",
      },
      {
        src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-files/bodySummaryFemale.png",
        alt: "Body Summary Female",
      },
    ],
  },
  {
    title: "Cover Page",
    heading:
      "Add that extra aesthetic zing to your Smart Reports with your very own Cover Page, that suits your brand and makes patients feel excited to read their reports.",
    picture: "coverPage.jpg",
    bannerPicture: "coverPageNew.png",
  },
  {
    title: "Test Recommender",
    heading:
      "Scientific algorithm-based additional test recommendation engine, which notifies patients on what else to get tested for to get the complete picture of their health.",
    picture: "testrecommendation.jpg",
  },
];

export default function SmartReportPage() {
  const GAEventsTracker = useGAEventsTracker("Smart Reports Activity");
  const [showMeeting, setShowMeeting] = React.useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  
  // Background SVG path - same as user journey page
  const backgroundSvgPath = "/images/userJourney/assets/job297-ploy-07c-blue-01.svg";

  const bannerContent = {
    title: "Smart Report",
    description:
      "Diagnostic labs struggle to engage patients with complex numbers. Smart Health Reports simplify medical test results for users with clear explanations, visualizations, and actionable insights, so that you become truly patient-centric.",
    image: "smartReportImage.svg",
    styles: { imageWidth: isSmallScreen ? "180px" : "335px" },
    features: [
      {
        logo: (
          <LocalPrintshopIcon
            sx={{ color: "#3567D6", fontSize: isSmallScreen ? "8px" : "30px" }}
          />
        ),
        text: "Print Versions",
      },
      {
        logo: (
          <PaletteIcon
            sx={{ color: "#3567D6", fontSize: isSmallScreen ? "8px" : "30px" }}
          />
        ),
        text: "Brand Colors",
      },
      {
        logo: (
          <ContentCopyIcon
            sx={{ color: "#3567D6", fontSize: isSmallScreen ? "8px" : "30px" }}
          />
        ),
        text: "Multiple Templates",
      },
    ],
    buttonText: "View Demo Report",
    link: "https://www.sample-reports.niroggyan.com",
    gaEvents: {
      category: "Smart Reports Activity",
      action: "sample-niroggyan opened",
    },
  };

  const reportTypes = {
    baseReport: [
      {
        title1: "Personal",
        title2: "Report",
        description:
          "Personalised reports highlighting the patient’s problematic parameters in great detail.",
        image: "personalReport.png",
        previewImages: [
          {
            src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-files/new-landing-page-resources/dynamic/digital/dynamic-digital-2.png",
            alt: "Personal Image 1",
          },
          {
            src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-files/new-landing-page-resources/dynamic/digital/dynamic-digital-3.png",
            alt: "Personal Image 2",
          },
        ],
        styles: {
          padding: isSmallScreen ? "8px 8px 0px 8px" : "14px 22px 0px 22px",
        },
      },
      {
        title1: "Total",
        title2: "Report",
        description:
          "Comprehensive reports for those who want to know the most about their test results, with deep-dive into all the parameters.",
        image: "totalReport.png",
        previewImages: [
          {
            src: "https://dn96iqv3kf32j.cloudfront.net/brochure-images/advanced-section/Advanced-Report-0001.jpg",
            alt: "Total Image 1",
          },
          {
            src: "https://dn96iqv3kf32j.cloudfront.net/brochure-images/advanced-section/Advanced-Report-0002.jpg",
            alt: "Total Image 2",
          },
          {
            src: "https://dn96iqv3kf32j.cloudfront.net/brochure-images/advanced-section/Advanced-Report-0003.jpg",
            alt: "Total Image 3",
          },
          {
            src: "https://dn96iqv3kf32j.cloudfront.net/brochure-images/advanced-section/Advanced-Report-0004.jpg",
            alt: "Total Image 4",
          },
          {
            src: "https://dn96iqv3kf32j.cloudfront.net/brochure-images/advanced-section/Advanced-Report-0005.jpg",
            alt: "Total Image 5",
          },
          {
            src: "https://dn96iqv3kf32j.cloudfront.net/brochure-images/advanced-section/Advanced-Report-0006.jpg",
            alt: "Total Image 6",
          },
          {
            src: "https://dn96iqv3kf32j.cloudfront.net/brochure-images/advanced-section/Advanced-Report-0007.jpg",
            alt: "Total Image 7",
          },
        ],
        styles: {
          padding: isSmallScreen ? "0px 8px 8px 8px" : "0px 22px 14px 22px",
        },
      },
      {
        title1: "Compact",
        title2: "Report",
        description:
          "Simple reports for those who want to quickly check their results with compact graphs, minimal text and lesser pages.",
        image: "compactReport.png",
        previewImages: [
          {
            src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-files/new-landing-page-resources/compact/digital/compact-digital-2.png",
            alt: "Compact Image 1",
          },
          {
            src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-files/new-landing-page-resources/compact/digital/compact-digital-3.png",
            alt: "Compact Image 2",
          },
        ],
        styles: {
          padding: isSmallScreen ? "8px 8px 0px 8px" : "14px 22px 0px 22px",
        },
      },
    ],
    addons: [
      {
        title1: "Body",
        title2: "Summary",
        description: "Select body summaries from a variety of options.",
        image: "bodySummary.png",
        previewImages: [
          {
            src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-files/bodySummaryMale.png",
            alt: "Body Summary Male",
          },
          {
            src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-files/bodySummaryFemale.png",
            alt: "Body Summary Female",
          },
        ],
        styles: { padding: isSmallScreen ? "8px" : "14px 22px" },
      },
      {
        title1: "Cover",
        title2: "Page",
        description: "Customize your cover page according to your brand color.",
        image: "coverPage.png",
        picture: "coverPage.jpg",
        styles: { padding: isSmallScreen ? "8px" : "14px 22px" },
      },
      {
        title1: "Test",
        title2: "Recommender",
        description:
          "Test recommender to notify the patients for follow-up tests.",
        image: "testRecommender.png",
        picture: "testrecommendation.jpg",
        styles: { padding: isSmallScreen ? "8px" : "14px 22px" },
      },
    ],
    powerFeatures: [
      {
        title1: "Trend",
        title2: "Report",
        description:
          "Present & historical test results explained with easy-to-understand graphs and dynamic information. Creates maximum value to catch problematic trends of patients.",
        image: "trendReport.png",
        previewImages: [
          {
            // src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-files/new-landing-page-resources/new-historical.jpg",
            src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-images/brochureHistorical1-page1.jpg",
            alt: "Trends Image 1",
          },
          {
            src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-images/brochureHistorical1-page2.jpg",
            alt: "Trends Image 2",
          },
          {
            src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-images/brochureHistorical1-page3.jpg",
            alt: "Trends Image 3",
          },
          {
            src: "https://niroggyan.s3.ap-south-1.amazonaws.com/brochure-images/brochureHistorical1-page4.jpg",
            alt: "Trends Image 4",
          },
        ],
        styles: {
          padding: isSmallScreen ? "8px 8px 0px 8px" : "22px 14px 0px 14px",
        },
      },
      {
        title1: "Language",
        title2: "Options",
        description:
          "View your report in your favourable language with various language options",
        image: "languageOptions.svg",
        styles: {
          padding: isSmallScreen ? "8px" : "22px 14px",
        },
      },
    ],
  };

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#ffffff",
        overflowX: "hidden",
        // Background SVG - same as user journey page
        backgroundImage: `url(${backgroundSvgPath})`,
        backgroundSize: "cover",
        backgroundPosition: "center top",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "scroll",
      }}
    >
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          padding: { xs: "96px 16px 40px", sm: "96px 24px 40px", md: "96px 48px 40px" },
        }}
      >
        <BannerSection data={bannerContent} />
      <Stack
        direction="column"
        gap={isSmallScreen ? 2 : 5}
        sx={{ marginTop: isSmallScreen ? "16px" : "38px" }}
      >
        <Box
          sx={{
            background: !isSmallScreen ? "rgba(64, 123, 255, 0.23)" : "",
            boxShadow: !isSmallScreen
              ? "4px 4px 2.1px 0px rgba(0,0,0,0.25)"
              : "",
            paddingY: "24px",
            borderRadius: "40px",
          }}
        >
          <Typography
            sx={{ textAlign: "center" }}
            mb={isSmallScreen ? "14px" : "27px"}
            variant={isSmallScreen ? "body3" : "h3"}
          >
            Smart Report Editions
          </Typography>
          <CenterBox sx={{ gap: isSmallScreen ? "6px" : "24px" }}>
            {reportTypes.baseReport.map((each) => (
              <ProductCard
                key={each.title1}
                data={each}
                GAEventsTracker={GAEventsTracker}
              />
            ))}
          </CenterBox>
        </Box>
        <Box
          sx={{
            background: !isSmallScreen ? "rgba(64, 123, 255, 0.23)" : "",
            boxShadow: !isSmallScreen && "4px 4px 2.1px 0px rgba(0,0,0,0.25)",
            paddingY: "24px",
            borderRadius: "40px",
          }}
        >
          <Typography
            sx={{ textAlign: "center" }}
            mb={isSmallScreen ? "14px" : "27px"}
            variant={isSmallScreen ? "body3" : "h3"}
          >
            Add-Ons
          </Typography>
          <CenterBox sx={{ gap: isSmallScreen ? "6px" : "24px" }}>
            {reportTypes.addons.map((each) => (
              <ProductCard
                key={each.title1}
                data={each}
                GAEventsTracker={GAEventsTracker}
              />
            ))}
          </CenterBox>
        </Box>
        <Box
          sx={{
            background: !isSmallScreen ? "rgba(64, 123, 255, 0.23)" : "",
            boxShadow: !isSmallScreen && "4px 4px 2.1px 0px rgba(0,0,0,0.25)",
            paddingY: "24px",
            borderRadius: "40px",
          }}
        >
          <Typography
            sx={{ textAlign: "center" }}
            mb={isSmallScreen ? "14px" : "27px"}
            variant={isSmallScreen ? "body3" : "h3"}
          >
            Power Features
          </Typography>
          <CenterBox sx={{ gap: "24px" }}>
            {reportTypes.powerFeatures.map((each) => (
              <ProductCard
                key={each.title1}
                data={each}
                GAEventsTracker={GAEventsTracker}
              />
            ))}
          </CenterBox>
        </Box>
      </Stack>
      </Box>
    </Box>
  );
}
